/**
 * Just view/template component, no model/data logic!
 */
import React
        // , { useState, useEffect } 
from 'react';
// import SEO from "./../../seo"

// Shop
// import { formatCurrency } from './../ext/utils/currency'

// s4n
import { injectIntl } from "gatsby-plugin-intl"
// import HttpClient from './../../../../utils/HttpClient'
// import $ from "jquery"



/**
 * Displays selected variation price
 * 
 * @param { intl, selectedVariation } props 
 */
const ComponentStateless = (props) => {

    const { intl } = props
    const t = intl.formatMessage

    const { selectedVariation } = props
    const printLabel = props.printLabel || false

    // const [exchangeRate, setExchangeRate] = useState(null);

    // /**
    //  * text === String
    //  */
    // const extractDomFromRenderedEntity = (text = null, className = null) => {
    //     if (typeof text === `undefined` || typeof className === `undefined`) {
    //         return null;
    //     }
    //     const $entityRenderedDom = $(text);
    //     const $node = $entityRenderedDom.find(className);
    //     return $node;
    // }

    // const fetchData = async () => {
    //     const response = await HttpClient.get(`/soft4net/exchange_rate/ecb/USD_PLN`, {});
    //     // console.log(response)
    //     if (200 === response.status) {
    //         setExchangeRate(Number(response.data));
    //     }
    // }

    /**
     * @see: https://reactjs.org/docs/hooks-effect.html
     * Same as componentDidMount() hook because we pass an empty array [] as second argument,
     * this argument watches for changes in passed arguments
     * In componentDidMount we have access to window object elsewhere not always!!!
     */
    // useEffect(() => {
    //     if (`PLN` === selectedVariation.price.currencyCode) {
    //         return;
    //     }

    //     fetchData();
    // }, []);

    

// @see: https://www.drupal.org/project/commerce_currency_resolver/issues/3120422 START
    // if (`PLN` !== selectedVariation.price.currencyCode && null !== exchangeRate) {
    //     selectedVariation.price.currencyCode = `PLN`;
    //     selectedVariation.price.number = selectedVariation.price.number * exchangeRate;
    // }
    // const priceResolvedAndFormatted = formatCurrency(selectedVariation.price.currencyCode, selectedVariation.price.number);

    // const response = await HttpClient.jsonapi(intl.locale, `commerce_product_variation/default`, `filter[entity_type][value]=commerce_product&filter[field_storage_config_type][value]=list_string`);
    // console.log(response)

// @see: https://www.drupal.org/project/commerce_currency_resolver/issues/3120422 STOP


    // console.log(selectedVariation)

    // const priceResolvedAndFormatted = extractDomFromRenderedEntity(selectedVariation.entityRendered, `.field--type-commerce-price .field__item`).text();
    if (!(selectedVariation && selectedVariation.resolvedPrice && selectedVariation.calculatedPrice)) {
        return null;
    }

    let hasDiscount = false;
    if (Number(selectedVariation.calculatedPrice.number) < Number(selectedVariation.resolvedPrice.number)) {
        hasDiscount = true;
    }

    return (
        <React.Fragment>
            {printLabel && 
                <React.Fragment>
                    {t({ id: "soft4net_shop_commerce_product_page_price" })}
                    {` `}
                </React.Fragment>
            }
            {hasDiscount && 
                <s className="px-1"><small>{selectedVariation.resolvedPrice.formatted}</small></s>
            }
            <strong>{selectedVariation.calculatedPrice.formatted}</strong>
            {` `}
            <span className="plus-vat">+ VAT</span>
        </React.Fragment>
    )
}

export default injectIntl(ComponentStateless)